import { render, staticRenderFns } from "./GrupoIndex.vue?vue&type=template&id=1a71ee07&scoped=true&"
import script from "./GrupoIndex.vue?vue&type=script&lang=js&"
export * from "./GrupoIndex.vue?vue&type=script&lang=js&"
import style0 from "./GrupoIndex.vue?vue&type=style&index=0&id=1a71ee07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a71ee07",
  null
  
)

export default component.exports